"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.radioFieldSchema = void 0;
exports.default = RadioField;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("zod");
exports.radioFieldSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            return zod_1.z.object({ [fieldName]: validation });
        },
    };
})({
    default: zod_1.z.string().min(1, 'Required'),
    notRequired: zod_1.z.string(),
});
function RadioField({ groupLabel, groupLabelVariant = 'bodyMediumBook', groupLabelColor = 'text.secondary', name, horizontalInputs = false, radioItems, formHelperText, required = true, dataTestId, }) {
    var _a;
    const { control } = (0, react_hook_form_1.useFormContext)();
    const labelId = (0, react_1.useId)();
    const { field, formState: { errors }, } = (0, react_hook_form_1.useController)({ name, control });
    const error = (0, react_hook_form_1.get)(errors, name);
    return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, { fullWidth: true, error: !!error, required: required, children: [groupLabel && ((0, jsx_runtime_1.jsx)(material_1.FormLabel, { id: labelId, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: groupLabelVariant, color: groupLabelColor, children: groupLabel }) })), (0, jsx_runtime_1.jsx)(material_1.RadioGroup, { row: horizontalInputs, value: field.value, onChange: field.onChange, "aria-labelledby": labelId, "data-test-id": dataTestId, children: radioItems.map((item) => ((0, jsx_runtime_1.jsx)(material_1.FormControlLabel, Object.assign({}, field, { value: item.value, control: (0, jsx_runtime_1.jsx)(material_1.Radio, { color: "secondary" }), label: item.label, componentsProps: {
                        typography: {
                            variant: 'bodyMediumBook',
                            color: 'text.secondary',
                        },
                    } }), item.label))) }), (0, jsx_runtime_1.jsx)(material_1.FormHelperText, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : formHelperText }) })] }));
}
//# sourceMappingURL=RadioField.js.map